import { useCallback, useEffect, useState, useSyncExternalStore } from 'react';

import { WSocket } from '../utils/WSocket';

export const useWSocket = (
    url: string | null,
    onMessage: (e: MessageEvent) => void,

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deps: Array<any>,
) => {
    const [socket, setSocket] = useState<WSocket | null>(null);

    useEffect(() => {
        let createdSocket: WSocket | null;
        if (url) {
            createdSocket = new WSocket(url);
            setSocket(createdSocket);
        } else {
            setSocket(null);
        }

        return () => {
            createdSocket?.disconnect();
        };
    }, [url]);

    useEffect(() => {
        socket?.on('message', onMessage);

        return () => {
            socket?.off('message', onMessage);
        };
    }, [...deps, socket]);

    const subscribe = useCallback(
        (callback: () => void) => {
            socket?.on('connectionState', callback);

            return () => {
                socket?.off('connectionState', callback);
            };
        },
        [socket],
    );
    const getSnapshot = useCallback(
        () => socket?.getConnectionState() ?? 'idle',
        [socket],
    );
    const connectionState = useSyncExternalStore(subscribe, getSnapshot);

    return { connectionState, socket };
};
